var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{directives:[{name:"t",rawName:"v-t",value:('Order.orders'),expression:"'Order.orders'"}]}),_c('OrderList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }